module.exports = __webpack_public_path__ + "static/media/t-shirt.8fb80fab.png";